import UnavailableMethodException from '@naturehouse/nh-essentials/lib/exceptions/UnavailableMethodException';
import type { RequestOptions } from '@naturehouse/nh-essentials/lib/requests/HttpClient';
import type HttpError from '@naturehouse/nh-essentials/lib/requests/HttpError';
import CollectionBase from '../common/CollectionBase';

export type VerificationCollectionData = Record<string, never>;

export type VerificationCollectionParams = {
    action: string;
};

export default class VerificationCollection extends CollectionBase<
    VerificationCollectionData,
    VerificationCollectionParams
> {
    static #instance: VerificationCollection | null = null;

    public static getInstance(): VerificationCollection {
        if (this.#instance === null) {
            this.#instance = new VerificationCollection();
        }

        return this.#instance;
    }

    public static destroyInstance(): void {
        this.#instance = null;
    }

    public add<RT = string>(
        data: VerificationCollectionData,
        params?: VerificationCollectionParams,
        headers?: RequestOptions['headers']
    ): Promise<RT | void> {
        return super.add<RT>(data, params, headers);
    }

    public async retrieve(): Promise<void> {
        throw new UnavailableMethodException();
    }

    public async update(): Promise<void> {
        throw new UnavailableMethodException();
    }

    public async delete(): Promise<void> {
        throw new UnavailableMethodException();
    }

    protected endpoint(params?: VerificationCollectionParams): string {
        if (!params?.action) {
            throw new Error('action is required');
        }

        return params.action;
    }

    protected onError(error: HttpError<AjaxResponseError>): void {
        throw error;
    }
}
